import React from "react";
import "./stylesheet/color-game.scss";
import ColorGame from "./components/ColorGame";

function App() {
  return <ColorGame />;
}

export default App;
